/* Dein Grinder Popup: Frage -> E-Mail -> SMS -> Gutschein */
(function () {
  var root = document.getElementById('DgPopup');
  if (!root) return;

  var KEY = 'dg_popup';
  var SNOOZE_DAYS = 5;
  var params = new URLSearchParams(location.search);
  var store = {
    get: function () { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } },
    set: function (v) { try { localStorage.setItem(KEY, JSON.stringify(Object.assign(this.get(), v))); } catch (e) {} }
  };

  var designMode = root.dataset.designMode === 'true';
  var forced = params.get('dg_popup') === '1';
  var state = store.get();
  var snoozed = state.closedAt && Date.now() - state.closedAt < SNOOZE_DAYS * 864e5;
  if (params.get('dg_popup') === '0') return;
  // Besucher:innen aus Klaviyo-Mails (bereits Abonnent:innen) nicht stören
  if (params.get('utm_medium') === 'email' || params.get('_kx')) store.set({ subscribed: true });
  if (!forced) {
    if (designMode && root.dataset.preview !== 'true') return;
    if (!designMode && (store.get().subscribed || snoozed)) return;
  }

  var klaviyoKey = root.dataset.klaviyoKey;
  var klaviyoList = root.dataset.klaviyoList;
  var code = root.dataset.code;
  var offer = root.dataset.offer;
  var answers = {};
  var lastFocus = null;

  var steps = root.querySelectorAll('.dgpp__step');
  function go(n) {
    steps.forEach(function (s) { s.classList.toggle('is-active', s.dataset.step === String(n)); });
    var target = n === 1 ? root.querySelector('.dgpp__panel') : root.querySelector('.dgpp__step.is-active input, .dgpp__step.is-active .dgpp__btn');
    if (target) setTimeout(function () { target.focus({ preventScroll: true }); }, 60);
    root.dataset.current = n;
  }

  function open() {
    lastFocus = document.activeElement;
    var img = root.querySelector('.dgpp__img[data-src]');
    if (img) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.documentElement.classList.add('dgpp-lock');
    go(forced && params.get('dg_popup_step') ? +params.get('dg_popup_step') : 1);
    track('Popup angezeigt');
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('dgpp-lock');
    setTimeout(function () { root.hidden = true; }, 250);
    if (!store.get().subscribed) store.set({ closedAt: Date.now() });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- Klaviyo Client-API (nur öffentlicher Schlüssel) ---------- */
  function kfetch(path, body) {
    if (!klaviyoKey) { console.info('[DG Popup] Klaviyo-Site-ID fehlt', path, body); return Promise.resolve(); }
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(klaviyoKey), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-10-15' },
      body: JSON.stringify(body)
    }).catch(function (e) { console.warn('[DG Popup] Klaviyo-Anfrage fehlgeschlagen', e); });
  }
  function track(name) {
    try { if (window.gtag) window.gtag('event', 'dg_popup', { step: name }); } catch (e) {}
  }
  function baseProps() {
    return {
      dg_signup_source: 'popup',
      dg_signup_page: location.pathname,
      dg_signup_at: new Date().toISOString(),
      dg_quiz_question: answers.question,
      dg_geschenk_fuer: answers.answer,
      dg_popup_offer: offer,
      dg_popup_code: code
    };
  }
  function upsertProfile(attrs, props) {
    return kfetch('profiles', { data: { type: 'profile', attributes: Object.assign({}, attrs, { properties: props }) } });
  }
  function subscribe(attrs, channels, props) {
    var subs = {};
    if (props) attrs = Object.assign({}, attrs, { properties: props });
    channels.forEach(function (c) { subs[c] = { marketing: { consent: 'SUBSCRIBED' } }; });
    var body = { data: { type: 'subscription', attributes: { custom_source: 'Dein Grinder Popup', profile: { data: { type: 'profile', attributes: Object.assign({}, attrs, { subscriptions: subs }) } } } } };
    if (klaviyoList) body.data.relationships = { list: { data: { type: 'list', id: klaviyoList } } };
    return kfetch('subscriptions', body);
  }
  function event(name, email, props) {
    return kfetch('events', { data: { type: 'event', attributes: {
      properties: props || {},
      metric: { data: { type: 'metric', attributes: { name: name } } },
      profile: { data: { type: 'profile', attributes: { email: email } } }
    } } });
  }
  // Code für diese Sitzung im Warenkorb hinterlegen (wird an der Kasse abgezogen)
  function applyCode() {
    if (!code) return Promise.resolve();
    return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {})
      .then(function () {
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Popup-Gutschein': code, 'Geschenk für': answers.label || '' } }) });
      }).catch(function () {});
  }

  /* ---------- Schritt 1: Frage ---------- */
  answers.question = (root.querySelector('[data-dgpp-question]') || {}).textContent;
  var replyEl = root.querySelector('[data-dgpp-reply]');
  root.querySelectorAll('.dgpp__answer').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('.dgpp__answer').forEach(function (b) { b.classList.toggle('is-picked', b === btn); });
      answers.answer = btn.dataset.answer;
      answers.label = btn.dataset.label || btn.textContent.trim();
      if (btn.dataset.reply && replyEl) replyEl.textContent = btn.dataset.reply;
      track('Antwort');
      setTimeout(function () { go(2); }, 220);
    });
  });

  /* ---------- Schritt 2: E-Mail ---------- */
  var emailForm = root.querySelector('[data-step="2"]');
  emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = emailForm.querySelector('input');
    var err = emailForm.querySelector('[data-dgpp-error]');
    var email = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.hidden = false; input.focus(); return; }
    err.hidden = true;
    answers.email = email;
    store.set({ subscribed: true, email: true });
    upsertProfile({ email: email }, Object.assign(baseProps(), { dg_sms_optin: false }))
      .then(function () { return subscribe({ email: email }, ['email'], Object.assign(baseProps(), { dg_sms_optin: false })); })
      .then(function () { return event('Popup Gutschein erhalten', email, { code: code, offer: offer, geschenk_fuer: answers.answer }); });
    applyCode();
    track('E-Mail');
    go(3);
  });

  /* ---------- Schritt 3: SMS ---------- */
  var smsForm = root.querySelector('[data-step="3"]');
  var phoneInput = smsForm.querySelector('input');
  var ccSel = smsForm.querySelector('select');
  smsForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var err = smsForm.querySelector('[data-dgpp-error]');
    var digits = phoneInput.value.replace(/\D/g, '').replace(/^00\d{2}/, '').replace(/^0/, '');
    if (digits.length < 9 || digits.length > 12) { err.hidden = false; phoneInput.focus(); return; }
    err.hidden = true;
    var phone = ccSel.value + digits;
    upsertProfile({ email: answers.email, phone_number: phone }, { dg_sms_optin: true, dg_sms_optin_at: new Date().toISOString() });
    subscribe({ email: answers.email, phone_number: phone }, ['sms'], { dg_sms_optin: true });
    store.set({ sms: true });
    track('SMS');
    go(4);
  });
  root.querySelector('[data-dgpp-skip-sms]').addEventListener('click', function () { go(4); });

  /* ---------- Schritt 4: Code ---------- */
  var copyBtn = root.querySelector('[data-dgpp-copy]');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    var t = code || '';
    (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function () {
      copyBtn.textContent = 'Kopiert ✓';
    }).catch(function () {
      var r = document.createRange(); r.selectNodeContents(root.querySelector('[data-dgpp-code]'));
      var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
    });
  });
  root.querySelector('[data-dgpp-claim]').addEventListener('click', function () {
    store.set({ subscribed: true });
    document.documentElement.classList.remove('dgpp-lock');
  });

  /* ---------- Schließen + Fokus ---------- */
  root.querySelectorAll('[data-dgpp-close]').forEach(function (b) { b.addEventListener('click', close); });
  root.addEventListener('click', function (e) { if (e.target === root) close(); });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      var f = Array.prototype.slice.call(root.querySelectorAll('.dgpp__x, .dgpp__step.is-active button, .dgpp__step.is-active input, .dgpp__step.is-active select, .dgpp__step.is-active a')).filter(function (el) { return !el.hidden && el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Öffnen: nach Verzögerung oder bei Exit-Intent (Desktop) ---------- */
  var opened = false;
  function openOnce() { if (opened) return; opened = true; open(); }
  var delay = (forced || designMode ? 0.6 : +root.dataset.delay || 7) * 1000;
  function start() {
    // erst nach der Cookie-Entscheidung starten (Banner aus snippets/dg-cookie-banner.liquid)
    if (window.DG_CONSENT_PENDING && !forced) { document.addEventListener('dg:consent-done', start, { once: true }); return; }
    setTimeout(openOnce, delay);
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) openOnce(); });
  }
  // nicht öffnen, während jemand gerade ein Foto im Customizer bearbeitet
  var origOpen = openOnce;
  openOnce = function () {
    var dgc = document.querySelector('.dgc.has-image');
    if (dgc && !forced) return;
    origOpen();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
